import React, { useEffect, useState } from "react";
import classes from "./Row.module.css";
import axios from "../../../axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faPlay,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { videolinkupdate } from "../../features/UserSlice";

export default function Row({ title, fetchUrl, isLargeRow }) {
  const [Movie, setMovie] = useState([]);
  const baseURL = "https://image.tmdb.org/t/p/original";
  const dispatch = useDispatch();
  useEffect(() => {
    async function moviedata() {
      try {
        const request = await axios.get(fetchUrl);
        setMovie(request.data.results);
        return request;
      } catch (error) {
        console.log(error.message);
      }
    }
    moviedata();
  }, [fetchUrl]);

  function sideScroll(element, direction, speed, distance, step) {
    var scrollAmount = 0;
    var slideTimer = setInterval(function () {
      if (direction === "left") {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }
  function onClickScroll(e) {
    const rowId = e.currentTarget.title;
    const selectrow = document.getElementById(rowId);
    if (e.currentTarget.value === "left") {
      sideScroll(selectrow, "left", 20, 500, 50);
    } else if (e.currentTarget.value === "right") {
      sideScroll(selectrow, "right", 20, 500, 50);
    }
  }
  //this function handling to get movie key for embeded for iframe and then dispatch it to redux for the rerender on screen
  function handleWatch(e) {
    const movieId = e.currentTarget.id;
    const type = e.currentTarget.title;
    const options = {
      method: "GET",
      credentials: "same-origin",
      headers: {
        accept: "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI5ZWI5YWNlOGYyN2Q0ZWEzNjA4N2I2YTBhNDNhY2EyZCIsInN1YiI6IjY0YTY3YmZkMDdmYWEyMDBjN2VjMDMwNSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.9Z04wgkmVL20VmJnDpUesSbyuMUiMEYzZqHWKqx7xxs",
      },
    };

    fetch(`https://api.themoviedb.org/3/${type}/${movieId}/videos`, options)
      .then((response) => response.json())
      .then((response) => {
        dispatch(
          videolinkupdate({
            key: response.results[0].key,
          })
        );
      })
      .catch((err) => console.error(err));
  }

  return (
    <div className={classes.row}>
      {title}
      <div className={classes.row_posters} id={title}>
        <button
          value="left"
          title={title}
          className={`${classes.left_click} ${classes.scroll_btn}`}
          onClick={onClickScroll}
        >
          <FontAwesomeIcon
            icon={faChevronLeft}
            style={{
              width: "20px",
              height: "40px",
              color: "#fff",
            }}
          />
        </button>
        {
        Movie.map(
          (movie, index) =>
            ((isLargeRow && movie.poster_path) ||
              (!isLargeRow && movie.backdrop_path)) && (
              <img
                id={movie.id}
                title={isLargeRow ? "tv" : "movie"}
                onClick={(e) => handleWatch(e)}
                className={`${classes.row_poster} ${
                  isLargeRow && classes.row_posterLarge
                }`}
                src={`${baseURL}${
                  isLargeRow ? movie.poster_path : movie.backdrop_path
                }`}
                alt={movie.name}
                key={index}
              />
            )
        )}

        <button
          value="right"
          title={title}
          className={`${classes.right_click} ${classes.scroll_btn}`}
          onClick={onClickScroll}
        >
          <FontAwesomeIcon
            icon={faChevronRight}
            style={{ width: "20px", height: "40px", color: "#fff" }}
          />
        </button>
      </div>
    </div>
  );
}

// export default Row;
